(function() {
    'use strict';
    angular
        .module('ccsTrApp')
        .factory('Delivery', Delivery);

    Delivery.$inject = ['$resource', 'DateUtils'];

    function Delivery ($resource, DateUtils) {
        var resourceUrl =  'api/deliveries/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createdOn = DateUtils.convertDateTimeFromServer(data.createdOn);
                        data.modifiedOn = DateUtils.convertDateTimeFromServer(data.modifiedOn);
                        data.start = DateUtils.convertLocalDateFromServer(data.start);
                        data.end = DateUtils.convertLocalDateFromServer(data.end);
                        data.est = DateUtils.convertLocalDateFromServer(data.est);
                        data.delEstimate = DateUtils.convertLocalDateFromServer(data.delEstimate);
                        data.payEstimae = DateUtils.convertLocalDateFromServer(data.payEstimae);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    data.start = DateUtils.convertLocalDateToServer(data.start);
                    data.end = DateUtils.convertLocalDateToServer(data.end);
                    data.est = DateUtils.convertLocalDateToServer(data.est);
                    data.delEstimate = DateUtils.convertLocalDateToServer(data.delEstimate);
                    data.payEstimae = DateUtils.convertLocalDateToServer(data.payEstimae);
                    return angular.toJson(data);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    data.start = DateUtils.convertLocalDateToServer(data.start);
                    data.end = DateUtils.convertLocalDateToServer(data.end);
                    data.est = DateUtils.convertLocalDateToServer(data.est);
                    data.delEstimate = DateUtils.convertLocalDateToServer(data.delEstimate);
                    data.payEstimae = DateUtils.convertLocalDateToServer(data.payEstimae);
                    return angular.toJson(data);
                }
            }
        });
    }
})();
